import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    votadoBtn: {
        padding: theme.spacing(1, 2),
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '& svg': {
            fill: theme.palette.common.white,
        },
        '&:hover': {
            backgroundColor: theme.palette.error.main,
            borderColor: theme.palette.error.main,
            transition: 'all 0.3s ease',
        },
    },
    votacaoBtn: {
        padding: theme.spacing(1, 2),
        border: "1px solid #ccc",
        borderRadius: theme.shape.borderRadius,
        width: "70px",
        height: 40,
        "& svg": {
            margin: 0,
            width: "22px",
            height: "22px",
        }
    },
    disabled: {
        cursor: 'not-allowed',
        borderColor: theme.palette.error.main,
        backgroundColor: "#f443360a",
        '& svg': {
            fill: theme.palette.error.main
        },
    },
    qtdeVotos: {
        '& h5': {
            fontWeight: 500,
            fontSize: '1.6rem',
        }
    }
}))